import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const COPY = defineMessages({
  BEST_VALUE: {
    id: 'Pricing.copy.BestValue',
    defaultMessage: 'BEST VALUE',
    desc: {
      id: 'Pricing.copy.BestValue',
      message: '[Type: Label][Vis.: high] - Default text for Package Ribbon',
      project: PROJECT_NAME,
    },
  },
  SAVE_PERCENTAGE: {
    id: 'Pricing.copy.SavePercentage',
    defaultMessage: 'Save {percentage}% *',
    desc: {
      id: 'Pricing.copy.SavePercentage',
      message: '[Type: Label][Vis.: high] - Percentage of savings displayed in Package Ribbon',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
